module.exports = __webpack_public_path__ + "img/image_3_3.0b346825.jpg";